export default __webpack_public_path__ + "static/media/title_mob.d00950da.svg";